import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import ActionBarStrip from '../../_partials/ActionBarStrip';
import CentralColumn from '../../../DeviationPage/_partials/CentralColumn';
import { useDeviationAttributes } from '../../../DeviationViews/hooks/useDeviationAttributes';
import EditButton from './EditButton';
import CopyLinkButton from './CopyLinkButton';
import MoreButton, { useHasMoreActions } from './MoreButton';
import DownloadButton from './DownloadButton';
import s from './StashActionBar.scss';
const StashActionBar = ({ deviation, isOwner })=>{
    const { t } = useTranslation();
    const isMobile = useContext(MobileContext);
    const hasMoreActions = useHasMoreActions(deviation);
    const { isEditable, isDownloadable } = useDeviationAttributes(deviation, isOwner);
    return /*#__PURE__*/ React.createElement(ActionBarStrip, {
        className: s['root']
    }, /*#__PURE__*/ React.createElement(CentralColumn, null, isMobile ? /*#__PURE__*/ React.createElement("div", {
        className: s['mobile-content-root']
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['mobile-row']
    }, /*#__PURE__*/ React.createElement("span", {
        className: s['visibility-disclosure']
    }, t('actionbar.stash.visibilityDisclosure')), hasMoreActions && /*#__PURE__*/ React.createElement("div", {
        className: s['mobile-more-button-container']
    }, /*#__PURE__*/ React.createElement(MoreButton, {
        deviation: deviation,
        className: s['mobile-more-button']
    }))), /*#__PURE__*/ React.createElement("div", {
        className: s['mobile-row']
    }, /*#__PURE__*/ React.createElement(CopyLinkButton, {
        deviation: deviation
    }), isDownloadable && !isOwner && /*#__PURE__*/ React.createElement(DownloadButton, {
        deviation: deviation
    }), isEditable && /*#__PURE__*/ React.createElement(EditButton, {
        deviation: deviation
    }))) : /*#__PURE__*/ React.createElement("div", {
        className: s['desktop-content-root']
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['left-side']
    }, /*#__PURE__*/ React.createElement("span", {
        className: s['draft-indicator']
    }, t('actionbar.stash.draftView'))), /*#__PURE__*/ React.createElement("div", {
        className: s['right-side']
    }, /*#__PURE__*/ React.createElement(CopyLinkButton, {
        deviation: deviation
    }), isEditable && /*#__PURE__*/ React.createElement(EditButton, {
        deviation: deviation
    }), isDownloadable && !isOwner && /*#__PURE__*/ React.createElement(DownloadButton, {
        deviation: deviation
    }), hasMoreActions && /*#__PURE__*/ React.createElement(MoreButton, {
        deviation: deviation
    })))));
};
StashActionBar.displayName = 'StashActionBar';
export default StashActionBar;
